import React from 'react';
import { Modal, Button } from 'antd';
import { message } from 'antd';
import './Login.css';
import AuthForm from './AuthForm';

interface MenuLoginProps {
  visible: boolean;
  loading: boolean;
  onCancel: () => void;
  onRegister: () => void;
  defaultTab?: 'student' | 'employer' | 'mentor';
}

const MenuLogin: React.FC<MenuLoginProps> = ({ visible, loading, onCancel, onRegister, defaultTab = 'student' }) => {

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      className="login-widget-modal"
      width={900}
    >
      <div className="login-widget-container">
        <AuthForm 
          mode="login" 
          defaultTab={defaultTab}
          onSuccess={() => {
            message.success('Login successful! Redirecting to dashboard...');
            onCancel();
          }}
          className="login-widget-form"
        />
        
        <div className="login-widget-footer">
          <span>Don't have an account? </span>
          <Button type="link" onClick={onRegister} className="register-link-btn">
            Register
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MenuLogin; 